module.exports = "../../app/cells/pages/guides/v2_resources/chart-pie-alt.erb";